// This file is auto-generated by st/api-base module

import { useCreateFetch } from '@st/api-base/composables/useCreateFetch'
import { useCreateRawFetch } from '@st/api-base/composables/useCreateRawFetch'
import { useCreateUseInfiniteList } from '@st/api-base/composables/useCreateUseInfiniteList'
import type { paths } from '#imports'
import { useApiConfig } from '#imports'

export const useStFetch = useCreateFetch<paths>(useApiConfig)

export function useRawStFetch() {
  return useCreateRawFetch<paths>(useApiConfig)
}

export const useInfiniteList = useCreateUseInfiniteList<paths>(useRawStFetch)
